// Barra de compra fixa do celular. Responsabilidades:
//   1) mostrar/esconder conforme o botão da coluna sai da tela (rolando pra baixo);
//   2) espelhar o botão real (texto + disabled) — combinação indisponível não pode ficar clicável
//      só na barra, porque o product-info já zerou o input[name=id] e o clique mandaria o form vazio;
//   3) copiar o preço novo depois de QUALQUER troca de opção (cor externa, interna, tamanho...);
//   4) manter --ds-buybar-h igual à altura REAL da barra, pro padding do body nunca desalinhar.
//
// Fix round 1: trocado "ds:variante" + setTimeout(400) por PUB_SUB_EVENTS.variantChange (síncrono,
// dispara depois que o product-info escreve o preço novo — mesmo padrão de subscribe/PUB_SUB_EVENTS
// que ds-bottom-nav.js já usa pra cartUpdate), corrigida a direção do IntersectionObserver e criada
// --ds-buybar-h.
const barra = document.querySelector("[data-ds-buybar]");
const ancora = document.querySelector(".ds-pdp__compra .product-form__submit");

if (barra && ancora && "IntersectionObserver" in window) {
  const botao = barra.querySelector(".ds-buybar__botao");
  const precoDestino = barra.querySelector("[data-ds-buybar-preco]");

  // --- mostrar/esconder (fix round 2, achado 1) ---------------------------------------------
  // isIntersecting: o botão real está visível, a barra não precisa existir. boundingClientRect.top
  // > 0 (sem isIntersecting): o botão ainda está mais abaixo na página — a pessoa ainda não chegou
  // nele, então a barra também fica escondida (senão ela aparece já no topo, antes de qualquer
  // rolagem: "não intersecta" também é verdade ANTES de chegar no botão, não só depois de passar
  // por ele — IntersectionObserver sozinho não distingue as duas direções).
  const MARGEM_FUNDO = 80; // mesmo corte usado no rootMargin do observer, só num lugar
  function escondida(rect) {
    const dentroDoLimite = rect.top < window.innerHeight - MARGEM_FUNDO && rect.bottom > 0;
    return dentroDoLimite || rect.top > 0;
  }
  function recalcularVisibilidade() {
    barra.hidden = escondida(ancora.getBoundingClientRect());
  }

  new IntersectionObserver(
    ([e]) => { barra.hidden = escondida(e.boundingClientRect); },
    { rootMargin: `0px 0px -${MARGEM_FUNDO}px 0px` }
  ).observe(ancora);

  // O 1º callback do observer roda com o layout ainda não assentado — imagens da galeria e fontes
  // ainda carregando empurram o botão pra baixo depois disso. Sem recalcular de novo, uma pessoa
  // parada na 1ª tela (não rolou ainda) nunca vê o estado corrigido, porque nada mais dispara um
  // callback do observer sem rolagem ou sem essas chamadas explícitas.
  window.addEventListener("load", recalcularVisibilidade);
  document.fonts?.ready?.then(recalcularVisibilidade);
  window.addEventListener("resize", recalcularVisibilidade);

  // --- espelhar o botão real (texto + disabled) ----------------------------------------------
  // 1ª palavra numa linha e o resto junto na 2ª ("ADICIONAR / AO CARRINHO", dono 2026-10-01): o
  // resto vai num .ds-nowrap, então o botão nunca fica mais estreito que "AO CARRINHO" — quem
  // encolhe é o bloco do preço (min-width: 0). Mesmo formato do Liquid (ds-buy-bar.liquid).
  function rotular(texto) {
    const [primeira, ...resto] = texto.split(/\s+/);
    botao.replaceChildren(primeira);
    if (!resto.length) return;
    const span = document.createElement("span");
    span.className = "ds-nowrap";
    span.textContent = resto.join(" ");
    botao.append(" ", span);
  }
  function espelharBotao() {
    const indisponivel = ancora.hasAttribute("disabled");
    botao.disabled = indisponivel;
    const texto = ancora.querySelector("span")?.textContent?.trim();
    if (texto) rotular(texto);
  }
  espelharBotao(); // estado inicial, antes de qualquer troca (ex.: 1ª combinação já esgotada)

  // Fix round 2, achado 2: quando a combinação escolhida NÃO existe, product-info.js
  // (handleUpdateProductInfo) chama setUnavailable() e RETORNA antes de publicar variantChange —
  // variant é null, o evento nunca dispara nesse caminho. Só dá pra pegar observando o botão real
  // direto: disabled muda por atributo; o texto muda porque o Dawn substitui todo o conteúdo do
  // <span> (textContent =), que é uma mutação de childList, não de atributo nem de texto solto.
  new MutationObserver(espelharBotao).observe(ancora, {
    attributes: true,
    attributeFilter: ["disabled"],
    childList: true,
    subtree: true,
  });

  // --- preço acompanha a variante ---------------------------------------------------------------
  function copiarPreco() {
    const origem = document.getElementById(`price-${barra.dataset.secao}`);
    const bloco = origem?.querySelector(".ds-price");
    if (!bloco || !precoDestino) return;
    // clona pra um elemento solto: a barra é compacta e não mostra a linha do Pix (decisão do
    // dono), então a linha some do clone antes de entrar na página — nunca mexe no original.
    const clone = bloco.cloneNode(true);
    clone.querySelector(".ds-price__pix")?.remove();
    precoDestino.replaceChildren(clone);
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (evento) => {
      if (evento?.data?.sectionId !== barra.dataset.secao) return; // outra seção (ex.: recomendados)
      copiarPreco();
      espelharBotao();
    });
  }

  // --- altura real da barra (fix round 2, achado 3) ---------------------------------------------
  // Em vez de confiar numa altura fixa — o compare_at pode quebrar linha em telas estreitas
  // (320-375px) e deixar a barra mais alta que qualquer número chutado — mede a altura REAL da
  // barra e escreve em --ds-buybar-h, que só o padding do body usa (a barra em si não tem
  // min-height nem height fixos: sem piso, o ResizeObserver sempre lê a altura que o conteúdo pede
  // de verdade, pra cima OU pra baixo — um min-height alimentado pela própria medição criaria um
  // cabo de guerra em que a barra nunca encolhe de volta, porque o box nunca fica menor que o
  // último valor escrito nele).
  if ("ResizeObserver" in window) {
    new ResizeObserver(([entry]) => {
      const altura = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
      if (altura > 0) document.documentElement.style.setProperty("--ds-buybar-h", `${Math.ceil(altura)}px`);
    }).observe(barra);
  }
}
